import { createSelector } from 'reselect';
import sortByName from 'library/helpers/sort-by-name';

export const getBarcodeCategories = (state) => state.barcodeCategories.data?.sort(sortByName);
export const getBarcodeCategoriesLoadingState = (state) => state.barcodeCategories.loading;

export const getBarcodeCategoriesFormatted = createSelector(
  getBarcodeCategories,
  (items) => items.map(({ category_name: name, category_id: id }) => ({ name, id })),
);

export const getBarcodeCategoriesOptions = createSelector(
  getBarcodeCategoriesFormatted,
  (items) => items.map(({ name, id }) => ({ value: id, text: name })),
);
